import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-300c1114"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "solutions-main" }
const _hoisted_2 = { class: "solutions-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "solutions-header-region" }
const _hoisted_5 = { class: "solutions-header-title" }
const _hoisted_6 = { class: "solutions-header-text" }
const _hoisted_7 = { class: "solutions-content" }
const _hoisted_8 = { class: "solutions-content-main" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "solutions-content-region" }
const _hoisted_11 = { class: "solutions-region-title" }
const _hoisted_12 = { class: "solutions-title-field1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "solutions-title-border" }, null, -1))
const _hoisted_14 = { class: "solutions-title-field3" }
const _hoisted_15 = { class: "solutions-region-box" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "solutions-region-box2"
}
const _hoisted_18 = { class: "solutions-box2-title" }
const _hoisted_19 = { class: "solutions-box2-text" }
const _hoisted_20 = { class: "solutions-box2-title" }
const _hoisted_21 = { class: "solutions-box2-text" }
const _hoisted_22 = { class: "solutions-box2-btnbox" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "solutions-foot" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "solutions-foot-main" }
const _hoisted_27 = { class: "solutions-foot-title" }
const _hoisted_28 = { class: "solutions-foot-inputs" }
const _hoisted_29 = { class: "solutions-foot-btn cursor hover-opacity-8" }
const _hoisted_30 = { class: "solutions-foot-detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "solutions-header-img",
        src: require('@/assets/img/solutions/solutions-sub-bg.png')
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.solutionsText.subField1), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.solutionsText.subField2), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("img", {
          src: _ctx.solutionsText.img,
          class: "solutions-content-img-bg"
        }, null, 8, _hoisted_9),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.solutionsText.field1), 1),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.solutionsText.field3), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutionsText.children, (btn) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.solutionsActive = btn.id),
                key: btn.id,
                class: _normalizeClass(['solutions-region-btn','cursor',btn.id===_ctx.solutionsActive?'active':''])
              }, _toDisplayString(btn.name), 11, _hoisted_16))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutionsText.children, (btn) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: btn.id
            }, [
              (btn.id===_ctx.solutionsActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(btn.scene?.name), 1),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(btn.scene?.description), 1),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(btn.function?.name), 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(btn.function?.titles?.join('、')), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.gotoDetail(btn)),
                        class: "solutions-box2-btn cursor hover-opacity-8"
                      }, _toDisplayString(_ctx.btnName), 9, _hoisted_23)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("img", {
        class: "solutions-foot-img",
        src: _ctx.solutionsText.footImg
      }, null, 8, _hoisted_25),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.solutionsText.footField1), 1),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_el_input, {
            class: "solutions-foot-input",
            placeholder: _ctx.solutionsText.footPlaceholder1
          }, null, 8, ["placeholder"]),
          _createVNode(_component_el_input, {
            class: "solutions-foot-input",
            placeholder: _ctx.solutionsText.footPlaceholder2
          }, null, 8, ["placeholder"]),
          _createVNode(_component_el_input, {
            class: "solutions-foot-input",
            placeholder: _ctx.solutionsText.footPlaceholder3
          }, null, 8, ["placeholder"]),
          _createVNode(_component_el_input, {
            class: "solutions-foot-input",
            placeholder: _ctx.solutionsText.footPlaceholder4
          }, null, 8, ["placeholder"])
        ]),
        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.btnName2), 1),
        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.solutionsText.footField2), 1)
      ])
    ])
  ]))
}